<template>
  <span @click="handleClick" class="ee-checkbox" :class="{'is-checked': checked}">
    <i class="ee-checkbox__icon"></i>
    <slot></slot>
  </span>
</template>
<script>
  export default {
    compName: 'ee-checkbox',
    props: {
      disabled: Boolean,
      value: [Number, String, Boolean], // 值
      checkValue: {
        type: [Number, String, Boolean],
        default: true
      }, // 选中的返回值
      uncheckValue: {
        type: [Number, String, Boolean],
        default: false
      } // 未选中的返回值
    },
    watch: {
      value () {
        this.curValue = this.value === undefined ? false : this.value
        this.checked = this.curValue === this.checkValue
      }
    },
    data () {
      return {
        checked: this.value === this.checkValue,
        curValue: this.value === undefined ? false : this.value
      }
    },
    methods: {
      handleClick () {
        if (this.disabled) return
        this.checked = !this.checked
        this.curValue = this.checked ? this.checkValue : this.uncheckValue
        this.$emit('input', this.curValue)
      }
    }
  }
</script>
<style src="../style/checkbox.css"></style>



// WEBPACK FOOTER //
// src/packages/checkbox/Checkbox.vue?1b71e12d